import React, { useState } from 'react';
import { StyledSearchInput, StyledSearchInputContainer } from './style';
import Icon from '../Icon';
import { useTranslation } from 'react-i18next';

type SearchInputType = {
  searchValue: string;
  setSearchValue: (searchValue: string) => void;
};
const SearchInput: React.FC<SearchInputType> = ({
  searchValue,
  setSearchValue
}) => {
  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState(false);
  return (
    <StyledSearchInputContainer isFocused={isFocused}>
      <Icon
        name="search"
        fontSize={8}
        ml={5}
        color={isFocused ? 'primaryBlue' : 'minorText'}
      />
      <StyledSearchInput
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        placeholder={t('branches.searchPlaceholder')}
        onFocus={(): void => setIsFocused(true)}
        onBlur={(): void => setIsFocused(false)}
      />
    </StyledSearchInputContainer>
  );
};

export default SearchInput;
